import { Button } from "primereact/button";

export const useGetInsurances = () => {
  const columns = [
    { field: "Provider", header: "Provider" },
    { field: "Description", header: "Description" },
    {
      field: "Amount",
      header: "Amount",
      body: (row: any) => `$${row.Amount.toFixed(2)}`,
    },
    {
      field: "Coverage",
      header: "Coverage",
      body: (row: any) => `$${row.Coverage.toLocaleString()}`,
    },
    { field: "LocationId", header: "Location ID" },
    {
      field: "",
      header: "",
      body: () => (
        <div className="flex gap-2 p-button-text p-button-sm">
          <Button className="p-button-text p-button-sm" />
        </div>
      ),
    },
  ];

  return { columns };
};
